import React from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

const CustomDatePicker = ({
  selected,
  onChange,
  placeholder = "Select Date",
  maxDate = new Date(),
  className = "",
}) => {

  const today = new Date();

  return (
    <div className="custom-datepicker-wrapper">
      <DatePicker
        selected={selected}
        onChange={onChange}
        dateFormat="dd/MM/yyyy"
        placeholderText={placeholder}
        maxDate={maxDate}
        excludeDates={[today]}
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={100}
        className={`input9 custom-datepicker-input ${className}`}
      />
    </div>
  );
};

export default CustomDatePicker;